import {
	CONSULTATION_KEY_TYPE,
	CONSULTATION_TARGET_KEY_TYPE,
	DEFAULT_TAX_ACCOUNTANT_NAME,
	RECOMMENDED_CUSTOMER_INFO,
	TaxAccountantNameModel
} from "@/shared/model";
import {FileModel} from "@/shared/model";
import * as z from "zod";
import {DEFAULT_MANAGER_INFORMATION, ManagerInformationModel} from "../../tax-corporation";

const schema = z.object({
	id: z.string(),
	editable: z.boolean(),
	department: z.string(),
	managerInformation: ManagerInformationModel.model,
	taxAccountantName: TaxAccountantNameModel.model,
	visitedAt: z.string(),
	wroteDate: z.string(),
	visitPurpose: CONSULTATION_KEY_TYPE.nullable(), // 유형
	visitPurposeDetail: CONSULTATION_TARGET_KEY_TYPE.nullable(), // 구분
	content: z.string(),
	files: z.array(FileModel.model),
	recommendedCustomers: z.array(RECOMMENDED_CUSTOMER_INFO).nullable()
});

const model = schema.transform((values) => ({
	...values
}));

export const VisitHistoryDetailResModel = {schema, model};
export type IVisitHistoryDetailResModel = z.infer<typeof VisitHistoryDetailResModel.model>;
export const DEFAULT_VISIT_HISTORY_DETAIL_RES: IVisitHistoryDetailResModel = {
	id: "",
	department: "",
	managerInformation: DEFAULT_MANAGER_INFORMATION,
	taxAccountantName: DEFAULT_TAX_ACCOUNTANT_NAME,
	visitedAt: "",
	wroteDate: "",
	visitPurpose: null,
	visitPurposeDetail: null,
	files: [],
	editable: false,
	content: "",
	recommendedCustomers: []
};
